export default "__VITE_ASSET__C_VVZ7tn__ 1200w";